<script lang="ts" setup>
import { onMounted, ref, watch } from 'vue';
import TextInput from '../TextInput.vue';   
import { formatPostalCode, isCandianPostalCode, isUSZipCode } from '../../lib/Api/Location';
import { HtmlChangeEventType } from '../../Enums/UiEnums';
import { ValidationState } from '../../lib/Types/Types';

    const props = withDefaults(defineProps<{
        modelValue: string|undefined,
        title?: string,
        disabled?: boolean,
        placeholder?: string,
        allowCanadian?: boolean,
        allowZipPlus4?: boolean,
        required?: boolean,
        invalidValueText?: string        
    }>(), {
        title: 'Postal Code',
        disabled: false,
        placeholder: 'Enter postal code',
        allowCanadian: false,
        allowZipPlus4: true
    });

    const emit = defineEmits<{
            (e: 'update:modelValue', value: string | undefined): void,
            (e: "validationState", state: ValidationState, msg?: string): void
    }>();


    defineExpose({performValidation});        

    const requiredText = "Required";
    const postalCode = ref<string>();

    function isValidPostalCode(): boolean {

        if (!postalCode.value || "" === postalCode.value.trim())
            return true;

        if (true === isUSZipCode(postalCode.value, props.allowZipPlus4))
        {                
            return true;
        }

        if (props.allowCanadian)
        {
            if (true === isCandianPostalCode(postalCode.value))
            {
                return true;
            }
        }
        return false;
	}

    function updatePostalCodeString()
    {
        postalCode.value = formatPostalCode(postalCode.value);
    }

    function updateInternalPostalCodeValue(val: string|number|undefined)
    {
        postalCode.value = val?.toString();
        performValidation();
    }

    function updatePostalCodeValue(val: string|number|undefined) {
        postalCode.value = val?.toString();
        performValidation();
        updatePostalCodeString();
        emit('update:modelValue', postalCode.value);
    }

    watch(postalCode, (newVal) => {
        emit('update:modelValue', postalCode.value);
    });

    onMounted(() => {
        postalCode.value = props.modelValue;
    });

    function performValidation(eventType?: HtmlChangeEventType)
    {
        // Make sure we check if we have a postal code value
        if (props.required)
        {
            if (!postalCode.value?.length)
            {
                emit("validationState", false, requiredText);
                return;
            }
        }

        if (!isValidPostalCode())
        {
            emit("validationState", false, props.invalidValueText ?? "Invalid postal code.");
            return;
        }

        emit("validationState", true);         
    }

</script>

<template>
    <TextInput 
        :textValue="postalCode"
        :title="'Postal Code'"
        :disabled="props.disabled"
        :placeholder="'Enter postal code'"
        :validator="isValidPostalCode"
        :required="props.required"
        @update:textValue="updateInternalPostalCodeValue"
        @change:textValue="updatePostalCodeValue"
        @blur="updatePostalCodeString"
        @paste:textValue="updatePostalCodeValue"
         />
</template>

